import type React from 'react';

export type WalkingIconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const WalkingIcon: React.FC<WalkingIconProps> = ({ size = '24', color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.849 12.88c-.043.358-.245.664-.554.877a1.703 1.703 0 0 1-1.162.269 1.703 1.703 0 0 1-1.067-.533c-.251-.28-.376-.624-.334-.982l.09-.753 3.116.37-.09.752zm.53-1.405L.545 11.02a.375.375 0 0 0-.266.07.35.35 0 0 0-.135.235l-.13 1.099a1.933 1.933 0 0 0 .509 1.525c.37.412.91.698 1.529.77a2.442 2.442 0 0 0 1.666-.391c.457-.313.784-.795.85-1.364l.13-1.1a.343.343 0 0 0-.075-.258.373.373 0 0 0-.242-.132zm1.088-8.157L4.234 10.07l-3.15-.367.308-6.869.002-.015a2.456 2.456 0 0 1 .801-1.566c.422-.37.954-.56 1.51-.495.554.066 1.027.374 1.351.833.323.46.49 1.065.413 1.71l-.002.018zm.177-2.167C5.215.541 4.561.108 3.792.017c-.769-.09-1.507.176-2.067.67a3.22 3.22 0 0 0-1.05 2.045l-.004.03-.002.028-.324 7.23a.365.365 0 0 0 .32.383l3.82.445a.367.367 0 0 0 .398-.303L6.181 3.44l.004-.024.003-.03a3.223 3.223 0 0 0-.544-2.234zm9.65 12.606a1.17 1.17 0 0 1-.228.95 1.598 1.598 0 0 1-.956.594 1.6 1.6 0 0 1-1.114-.152 1.172 1.172 0 0 1-.596-.775l-.148-.7 2.894-.616.148.699zm.048-1.415l-3.562.759a.351.351 0 0 0-.216.145.329.329 0 0 0-.05.249l.218 1.02c.112.529.46.954.917 1.207a2.296 2.296 0 0 0 1.599.224 2.296 2.296 0 0 0 1.368-.856c.314-.417.459-.947.346-1.475l-.217-1.022a.33.33 0 0 0-.147-.207.352.352 0 0 0-.256-.044zM13.837 4.73l.948 6.402-2.923.627-1.81-6.224-.003-.014a2.323 2.323 0 0 1 .239-1.643c.265-.458.682-.788 1.198-.897.516-.11 1.03.02 1.46.333.428.31.76.8.887 1.4l.004.016zm-.5-1.988c-.568-.414-1.284-.602-1.998-.45-.714.153-1.291.615-1.641 1.226a3.038 3.038 0 0 0-.317 2.144l.006.027.006.026 1.906 6.553a.345.345 0 0 0 .4.245l3.546-.761a.347.347 0 0 0 .264-.394l-.998-6.737-.004-.022-.006-.027a3.035 3.035 0 0 0-1.164-1.83z"
        fillRule="evenodd"
      />
    </svg>
  );
};
